import { api } from "@shared/services/api-client";
import type { ApiResponse } from "@shared/types/api.types";
import type { BaziChart, BaziInput } from "./types";

/** Public endpoint: no token is sent, and a 401 is never turned into a refresh or a sign-out. */
export async function calculateBazi(input: BaziInput): Promise<BaziChart> {
  const response = await api.post<ApiResponse<BaziChart>>("/bazi/calculator", input, { auth: false });
  return response.data;
}
